import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/pro-light-svg-icons";
import { RateRulesEditor } from "./RateRulesEditor";
import type { RateRule } from "./rateRules";
import "./effort.css";

interface Props {
  rules: RateRule[];
  onChange: (rules: RateRule[]) => void;
}

/** "Level of Effort Adjustments": the rate-rules editor under a field label. */
export const LoeAdjustmentsField = ({ rules, onChange }: Props) => (
  <div className="governanceRateRules">
    <Form.Label>
      Level of Effort Adjustments
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="gov-rate-rules-info">
            Rules are checked in order. The first rule whose conditions all hold
            replaces the percentage above; if none match, the percentage above
            applies. A rule at 0% marks the governance not applicable.
          </Tooltip>
        }
      >
        <span
          className="governanceInfoIcon"
          tabIndex={0}
          aria-label="About level of effort adjustments"
        >
          <FontAwesomeIcon icon={faCircleInfo} />
        </span>
      </OverlayTrigger>
    </Form.Label>
    <RateRulesEditor rules={rules} onChange={onChange} />
  </div>
);
